import {
  ColorsNeutral500,
  ColorsPrimary500,
  ColorsSuccess900,
} from '@efexteam/design-tokens';
import { Actions, Can, Subjects } from '@efexteam/permission-manager';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { Box, Card, Grid2, Stack, Typography } from '@mui/material';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import { launchToSpace, logoEfexInvoice } from '@/assets';

const ValidationsView = () => {
  const { t } = useTranslation();
  const { whiteLabelState } = useWhiteLabelService();
  const userProfile = useSelector(selectProfileData);

  const { isKyc, is_email_confirmed: isEmailConfirmed } = userProfile || {};

  if (isEmailConfirmed && isKyc) return null;

  return (
    <Can action={Actions.MANAGE} subject={Subjects.TEAM_MEMBERS}>
      <Card className="mb-4 p-5">
        <Grid2 container>
          <Grid2 size={12}>
            <Box className="flex items-center justify-start">
              <Typography variant="h5">
                {t(
                  whiteLabelState?.organizationID
                    ? 'lngWelcomeWhiteLabel'
                    : 'regWelcome'
                )}{' '}
              </Typography>
              {!whiteLabelState?.organizationID && (
                <img
                  src={logoEfexInvoice}
                  alt="Efex"
                  className="h-[30px] w-auto inline m-0 ml-2"
                />
              )}
            </Box>
            <Typography color={ColorsNeutral500}>
              {t('activateWelcome')}
            </Typography>
          </Grid2>
          <Grid2 container className="pt-6 w-full">
            <Grid2
              size={{ xs: 12, md: 4 }}
              className="flex items-center justify-center"
            >
              <img
                className="max-w-[200px]"
                src={launchToSpace}
                alt="complete onboarding"
              />
            </Grid2>
            <Grid2
              size={{ xs: 12, md: 8 }}
              className="flex !flex-col gap-4 items-center justify-center"
            >
              <Link to="/validate-account" className="block w-full">
                <Card className="shadow-lg hover:shadow-md rounded-md cursor-pointer p-5">
                  <Stack direction="row" spacing={3} alignItems="center">
                    <RocketLaunchIcon
                      fontSize="large"
                      sx={{
                        color: !isEmailConfirmed
                          ? ColorsPrimary500
                          : ColorsSuccess900,
                      }}
                    />
                    <Typography
                      color={
                        !isEmailConfirmed ? ColorsPrimary500 : ColorsSuccess900
                      }
                      className={`!font-bold `}
                      variant="body1"
                    >
                      {t(
                        !isEmailConfirmed
                          ? 'activateValidate'
                          : 'activateValidateSuccess'
                      )}
                    </Typography>
                    <ArrowRightIcon
                      fontSize="large"
                      sx={{
                        color: !isEmailConfirmed
                          ? ColorsPrimary500
                          : ColorsSuccess900,
                      }}
                      className="!ml-auto"
                    />
                  </Stack>
                </Card>
              </Link>
              {!isKyc ? (
                <Link to="/onboarding" className="block w-full">
                  <Card className="shadow-lg hover:shadow-md rounded-md cursor-pointer p-5">
                    <Stack direction="row" spacing={3} alignItems="center">
                      <RocketLaunchIcon
                        fontSize="large"
                        sx={{ color: ColorsPrimary500 }}
                      />
                      <Box>
                        <Typography
                          color={ColorsPrimary500}
                          className=" !font-bold"
                          variant="body1"
                        >
                          {t('activateHeader')}
                        </Typography>
                        <Typography
                          color={ColorsNeutral500}
                          className="text-primary-text"
                          variant="body2"
                        >
                          {t('onbMoreInformationAboutYou')}
                        </Typography>
                      </Box>
                      <ArrowRightIcon
                        fontSize="large"
                        sx={{ color: ColorsPrimary500 }}
                        className="!ml-auto"
                      />
                    </Stack>
                  </Card>
                </Link>
              ) : null}
            </Grid2>
          </Grid2>
        </Grid2>
      </Card>
    </Can>
  );
};

export default ValidationsView;
